module.exports = __webpack_public_path__ + "static/media/close.d2eac24c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui_icons/close.svg
// module id = 38
// module chunks = 0